export default "__VITE_ASSET__CG_vHrB7__"